import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';
import { socket } from '../../../../index';
import { snackActions } from '../../../sc-utilities/SnackBar';
import config from "../../../../config/config";
import { download } from "../../../sc-utilities/download.utils";
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import { ORDER } from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore"

// snackActions.snackBar
// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'palettes/order',
    pluginName: 'PALETTE',
    entityName: 'ORDER',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// const updateDownloadProgress = progress => {
//     return {
//         type: 'DOWNLOAD|DOWNLOAD_PROGRESS',
//         downloadProgress: progress.downloadProgress,
//         maxSize: progress.maxSize,
//         currentSize: progress.currentSize,
//         snackBar: progress.snackBar,
//         data: progress,
//         name: progress.name
//     };
// };

// Fetch order action creators

export const fetchOrderInit = () => {
    return crudActions.fetchInit();
};
export const fetchOrderStart = () => {
    return crudActions.fetchStart();
};
export const fetchOrderSuccess = (fetchOrderCount, listOrderCount) => {
    return crudActions.fetchSuccess(fetchOrderCount, listOrderCount);
};
export const fetchOrderFail = () => {
    return crudActions.fetchFail();
};

export const fetchOrderCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchOrderStart());
        try {
            let countRes = await rest.post("palettes/order/count", filterData);

            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchOrderSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchOrderFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch orders."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchOrderFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch orders."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchOrder = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchOrderStart());
        try {
            let listRes = await rest.post("palettes/order/list", { ...filterData, doesHavePalettes: true });
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchOrderSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchOrderFail());
            return []

        } catch (error) {
            dispatch(fetchOrderFail());
            return []

        }
    }
}

export const fetchOrders = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("palettes/order/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let orders = [];
                for (var order of res.data.result.data) {
                    orders.push({
                        value: order.OrderID,
                        displayValue: `${order.Name} (${order.OrderInventoryID})`
                    });
                }
                return orders;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list order "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchTransportCollies = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/palettes/transportColli/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let transportCollies = [];
                for (var transportColli of res.data.result.data) {
                    transportCollies.push({
                        value: transportColli.TransportColliID,
                        displayValue: `${transportColli.Name} (${transportColli.TransportColliInventoryID})`,
                        orderID: transportColli?.Order.OrderID
                    });
                }
                return transportCollies;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list order "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};



// Load order action creators
export const loadOrderInit = () => {
    return crudActions.loadInit();
};
export const loadOrderStart = () => {
    return crudActions.loadStart();
};
export const loadOrderSuccess = loadedOrder => {
    return crudActions.loadSuccess(loadedOrder);
};
export const loadOrderFail = error => {
    return crudActions.loadFail(error);
};
export const loadOrder = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Create order  action creators
export const createOrderInit = () => {
    return crudActions.createInit();
};
export const createOrderStart = () => {
    return crudActions.createStart();
};
export const createOrderSuccess = createdOrder => {
    return crudActions.createSuccess(createdOrder);
};
export const createOrderFail = error => {
    return crudActions.createFail(error);
};
export const createOrder = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createOrderStart());
        try {
            let res = await rest.post('/palettes/order/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createOrderSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created order.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createOrderFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create order."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create order."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createOrderFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit order  action creators
export const editOrderInit = () => {
    return crudActions.editInit();
};
export const editOrderStart = () => {
    return crudActions.editStart();
};
export const editOrderSuccess = editedOrder => {
    return crudActions.editSuccess(editedOrder);
};
export const editOrderFail = error => {
    return crudActions.editFail(error);
};

export const editOrder = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editOrderStart());
        try {
            let res = await rest.post('/palettes/order/save', { ...params });
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated order.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editOrderFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit order."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create order."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editOrderFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete order action creators
export const bulkDeleteOrdersInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteOrdersStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteOrdersSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteOrdersFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteOrders = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteOrdersStart());
        try {
            let res = await rest.post('/palettes/order/bulk_delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteOrdersSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully delete order ${params.Name}.`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            dispatch(bulkDeleteOrdersFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete order."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete order."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteOrdersFail(error));
            snackActions.snackBar({
                message: `${error.message ? error.message : "Cannot delete order."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Delete order  action creators
export const deleteOrderInit = () => {
    return crudActions.deleteInit();
};
export const deleteOrderStart = () => {
    return crudActions.deleteStart();
};
export const deleteOrderSuccess = deletedOrder => {
    return crudActions.deleteSuccess(deletedOrder);
};
export const deleteOrderFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteOrder = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// custom functions
export const listFilePatterns = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/file_patterns/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const filePatternsOption = [{ value: "filePattern_none", displayValue: "None" }];
                for (var filePattern of res.data.result.data) {
                    filePatternsOption.push({ value: filePattern.FilePatternID, displayValue: filePattern.Name });
                }
                return filePatternsOption;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const listReportInformation = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/report_data/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const reportInfoOption = [{ value: "reportInfo_none", displayValue: "None" }];
                for (var reportInfo of res.data.result.data) {
                    reportInfoOption.push({ value: `${reportInfo.ReportDataID}`, displayValue: reportInfo.Name });
                }
                return reportInfoOption;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const generateReports = (order, translations) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            order['SocketID'] = socket.id.split('#')[1];
            let res = await rest.post('/report/create-collection', order);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: translations['create_collection_started'] || `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const redisTopic = res.data.result.data.RedisTopic;
                socket.on(redisTopic, async msg => {
                    const { Status, ErasureReportID, RedisTopic } = msg;
                    const { OrderInventoryID, Generated, ToGenerate, Message } = msg;
                    snackbarStore.dispatch(snackbarActions.showCollection({ type: ORDER, collection: { OrderInventoryID, Generated, ToGenerate } }));
                    if (Status === 'error') {
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: ORDER, collection: { OrderInventoryID, Generated, ToGenerate } }));
                        return snackActions.snackBar({
                            message: Message || translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                            options: {
                                variant: 'error'
                            }
                        });
                    }

                    if (Status === 'generated') {
                        const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${order.ActiveCustomerID}`;
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: ORDER, collection: { OrderInventoryID, Generated, ToGenerate } }));
                        await download(objUrl);
                        snackActions.snackBar({
                            message: translations['create_collection_finished'] || `Create collection finished.`,
                            options: {
                                variant: 'success'
                            }
                        });
                    }

                });
            } else {
                snackActions.snackBar({
                    message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}


export const generateStorageReports = order => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/order/generate_storages_report', order);
            if (res.data.status === 200) {
                const redisTopic = res.data.result.data.RedisTopic;

                socket.once(`${redisTopic}|0`, () => {
                    snackActions.snackBar({
                        message: `Erasure report starting.`,
                        options: {
                            variant: 'info'
                        }
                    });

                    // socket.on(`${redisTopic}|1`, msg => {
                    //     dispatch(updateDownloadProgress({ downloadProgress: Math.floor(parseInt(msg.split('%')[0])), snackBar: true, name: `Storage Report for ${order.Name}`, OrderID: order.OrderID });
                    // });

                    socket.once(`${redisTopic}|2`, async msg => {
                        if (msg.Message.name === 'ERROR') {
                            snackActions.snackBar({
                                message: `Error: Report failed. Please contact administrator.`,
                                options: {
                                    variant: 'error'
                                }
                            });
                            return false;
                        }
                        const reportID = msg.data;
                        const filename = msg.name;

                        let file = await dispatch(actionDownload.downloadErasure(reportID, order.ActiveCustomerID, filename));
                        if (file) {
                            downloadFile(file, filename);
                            return true;
                        }
                    });
                });
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot generate report."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }

        } catch (error) {
            return false;
        }
    };
}

export const unpairedBulkExternalOrderAction = () => {
    return ({
        type: 'EXTERNAL_ORDER',
    });
}

export const unpairedBulkExternalOrder = (externalIDs, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/order/bulk_unpair', { OrderExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID }, options);
            dispatch(unpairedBulkExternalOrderAction());
            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                if (res && res.canceled) {
                    return false;
                }
                return false;

            }
        }
        catch (error) {
            return false;
        }
    };
}

export const unpairedExternalOrder = (externalID, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/order/unpair', { OrderExternalInfoID: externalID.data, ActiveCustomerID: externalID.ActiveCustomerID }, options);
            dispatch(unpairedBulkExternalOrderAction());
            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                if (res && res.canceled) {
                    return false;
                }
                return false;

            }
        } catch (error) {
            return false;
        }
    };
}


export const galleryTrue = () => {
    return ({
        type: 'GALLERY_OPEN_ORDER',
    });
}


export const setColumnsDraggedData = (data) => {
    return ({
        type: 'HANDLE_DRAGGED_SET',
        columns: data
    });
}

export const ClearState = (data) => {
    return ({
        type: 'CLEAR_STATE',
    });
}


export const fetchOperatingSystems = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/operating_systems/list', { listAll: true, ...params }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const operatingSystems = [];
                for (var os of res.data.result.data) {
                    operatingSystems.push({ value: os.OperatingSystemID, displayValue: `${os.Name}` });
                }
                return operatingSystems;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const updatePresets = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/order/update-presets', params, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                return { status: true };
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return { status: false };
            }

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { status: false };
        }
    };
}

export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}
export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, q: { Visible: [1] }, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}
export const fetchPrinters = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch printers."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}

export const fetchCollies = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('colli/list', { listAll: true, formatForWEBUI: true, ...id, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;

            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const fetchOrdersPreset = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('palettes/order/list', { ...id, listAll: true, formatForWEBUI: true, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}
